import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { mapResponsive } from '@chakra-ui/utils';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'imageWrap', 'image', 'content'];
var baseStyle = function baseStyle(props) {
  var isOverflowing = props.isOverflowing,
    imageWidth = props.imageWidth,
    spacingBottom = props.spacingBottom,
    spacingLeft = props.spacingLeft;
  return {
    container: {
      display: 'flex'
    },
    imageWrap: _objectSpread(_objectSpread(_objectSpread({}, !isOverflowing && {
      mr: 4
    }), isOverflowing && {
      position: 'relative',
      ml: 2
    }), {}, {
      flexShrink: 0,
      flexGrow: 0,
      flexBasis: imageWidth,
      d: {
        base: 'none',
        md: 'block'
      }
    }),
    image: _objectSpread(_objectSpread({}, isOverflowing && {
      position: 'absolute',
      left: mapResponsive(spacingLeft, function (v) {
        return -v;
      }),
      bottom: mapResponsive(spacingBottom, function (v) {
        return -v;
      })
    }), {}, {
      width: '100%'
    }),
    content: {}
  };
};
var defaultProps = {};
var CardColumnWrapper = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { CardColumnWrapper as default };